import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { CompanyAppendix } from '../types';

type BulkArchiveVariables = {
  appendixIds: string[];
  isArchived: boolean;
};

type BulkArchiveResult = {
  appendices: CompanyAppendix[];
  skippedIds: string[];
};

export const useBulkArchiveCompanyAppendices = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading } = useMutation<
    { data: BulkArchiveResult },
    Error,
    BulkArchiveVariables
  >({
    mutationFn: ({ appendixIds, isArchived }) =>
      api.post<BulkArchiveResult>('company-appendices/bulk-archive', {
        appendixIds,
        isArchived,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['company-appendices'] });
    },
  });

  const bulkArchiveCompanyAppendices = async (appendixIds: string[], isArchived: boolean) => {
    const response = await mutateAsync({ appendixIds, isArchived });
    return response.data;
  };

  return {
    bulkArchiveCompanyAppendices,
    isLoading,
  };
};
